import PropTypes from 'prop-types';

import { getStyle } from 'helper/getStyle';
import { Input } from 'components/simple/Input';

const styles = {
  control: ({ palette, breakpoints, spacing }) => ({
    gap: 2,
    '.MuiInputBase-root': {
      borderRadius: '10px !important',
      borderColor: `${palette.colors.darkPale} !important`,
      '.MuiInputBase-input': {
        padding: `${spacing(2)} !important`,
        [breakpoints.up('md')]: {
          padding: `${spacing(4)} !important`,
        },
      },
    },
  }),
  input: ({ breakpoints }, autoExpand) => ({
    ...(!autoExpand && {
      height: 235,
      [breakpoints.up('sm')]: {
        height: 170,
      },
    }),
    '.MuiInputBase-input': {
      boxSizing: 'border-box',
      ...(!autoExpand && { height: '100% !important' }),
    },
  }),
  label: {
    fontWeight: 500,
  },
};

const MultilineTextField = ({ customStyles = {}, autoExpand = false, ...props }) => (
  <Input
    minRows={4}
    {...props}
    multiline
    autoExpand={autoExpand}
    customStyles={{
      control: (theme) => ({
        ...getStyle(styles.control, theme),
        ...getStyle(customStyles.control, theme),
      }),
      input: (theme) => ({
        ...getStyle(styles.input, theme, autoExpand),
        ...getStyle(customStyles.input, theme),
      }),
      label: (theme) => ({
        ...getStyle(styles.label, theme),
        ...getStyle(customStyles.label, theme),
      }),
    }}
  />
);

MultilineTextField.propTypes = {
  customStyles: PropTypes.shape({
    control: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    label: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }),
  innerRef: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  withHiddenLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  error: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
    ref: PropTypes.shape({}),
  }),
  inputProps: PropTypes.shape({
    maxLength: PropTypes.number,
  }),
  minRows: PropTypes.number,
  autoExpand: PropTypes.bool,
};
export default MultilineTextField;
